import { countrySchema } from "@redotech/redo-platform-common/geographic-unit";
import * as z from "zod";

export const getCountries = {
  name: "getCountries" as const,
  description:
    "Countries a location condition accepts. Country, state and city dimensions are hierarchical: a state needs its country code, a city needs both.",
  mutates: false,
  input: z.null(),
  output: z.array(countrySchema),
};
